import _api from './_api'
import _http from './_http'

const dict = {
  mainDict: _http.get(_api.common.libSass.saasDict),
  dict(key) {
    return new Promise((resolve, reject) => {
      dict.mainDict.then(main => {
        const mainPromise = dict.mainPromise = dict.mainPromise || _http.get(_api.common.libSass.saasDict, { params: { file: main.json } })
        mainPromise.then(mainContent => {
          if (dict[key] = mainContent.content.find(item => item.name === key)) {
            dict[key].promise = dict[key].promise || _http.get(_api.common.libSass.saasDict, { params: { file: dict[key].url } })
            dict[key].promise.then(resolve, reject)
          } else reject(key)
          dict.mainDictContent = mainContent
        }, reject)
      }, reject)
    })
  },
  dist() {
    return dict.distByDict('locCN')
  },
  // 生成级联菜单
  distByDict(dictName) {
    return dict.dict(dictName).then(payload => {
      const arr = Object.keys(payload.content).map(dist2 => {
        return {
          value: dist2,
          label: payload.content[dist2].nameZh,
          title: payload.content[dist2].nameZh,
          children: [],
          loading: false
        }
      })
      arr.unshift({ value: '00', label: '全国', title: '全国' })
      arr.getChildren = (node, callback) => {
        node.loading = true
        if (node.value.length == 2) {
          const dist4 = payload.content[node.value].dist4
          node.children = Object.keys(dist4).map(item => {
            return {
              value: item,
              label: dist4[item].nameZh,
              title: dist4[item].nameZh,
              children: [],
              loading: false
            }
          })
          node.loading = false
          node.children.unshift({ value: node.value + '00', label: '全部', title: '全部' })
          callback()
        } else if (node.value.length == 4) {
          const dist6 = payload.content[node.value.substr(0, 2)].dist4[node.value].dist6
          node.children = Object.keys(dist6).map(item => {
            return {
              value: item,
              label: dist6[item].nameZh,
              title: dist6[item].nameZh
            }
          })
          node.children.unshift({ value: node.value + '00', label: '全部', title: '全部' })
          node.loading = false
          callback()
        }
      }
      console.log("dist", arr)
      return arr
    })
  },
  dist6nameZh(val) {
    return dict.dict('locCN').then(payload => {
      var nameZh = '',
        dict2, dict4, dict6
      if (dict2 = payload.content[val.substr(0, 2)]) {
        nameZh = dict2.nameZh + ' '
        if (dict4 = dict2.dist4[val.substr(0, 4)]) {
          nameZh += dict4.nameZh + ' '
          if (dict6 = dict4.dist6[val]) {
            nameZh += dict6.nameZh
          }
        }
      }
      return nameZh || '--'
    })
  },
  getDist6Req(val) {
    return val ? [val.substr(0, 2), val.substr(0, 4), val] : []
  },
  getDist6Res(val) {
    return val && val instanceof Array && val.length > 0 ? (val[val.length - 1] + '000000').substr(0, 6) : ''
  },
  save(node) {
    const dictContent = {}
    node.form.map(item => dictContent[item.key] = item.value)
    return _http.post(_api.common.libSass.saasDict, { file: node.url, dictContent: dictContent })
  }
}

export default dict